// i18n config
export const messagesOfStakeBack = {
  ng: {
    stakeBackUp: '2M',
    stakeBackExtra: '100,000'
  },
  gh: {
    stakeBackUp: '20K',
    stakeBackExtra: '1,000'
  },
  ug: {
    stakeBackUp: '20M',
    stakeBackExtra: '650,000'
  },
  zm: {
    stakeBackUp: '',
    stakeBackExtra: ''
  }
}
